<template>
<header :style="topBannerNavBg">
  <div class="container">
    <div id="nav">
      <router-link class="logo" to="/" tag="div">
        <img src="@/assets/images/logo2.png" alt="" />
      </router-link>

      <div class="login nav-menu-login">
        <ul>
          <li v-for="(item, i) in navItems" :key="i" @click="toLink(item.link, $event)" @change="change" :class="{ selected: item.isSelected }">
            <el-badge is-dot class="item" :hidden="item.isred">{{ item.text }}</el-badge>
          </li>
        </ul>
      </div>
      <div class="login logined" v-if="hasToken">
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <ul>
              <li class="loginhead">
                <img class="headpicture" v-if="headicon" :src="imgUrl + headicon" alt="" />
                <img class="headpicture" v-else src="../assets/images/mycenterheadpicture.png" alt="" /><span class="logintext">{{ username }}</span>
              </li>
            </ul>
          </span>
          <el-dropdown-menu slot="dropdown">
            <router-link :to="{path:'/mycenter',query:{roleId:userid}}">
              <el-dropdown-item icon="el-icon-s-home" @click.native="load()">个人中心</el-dropdown-item>
            </router-link>
            <el-dropdown-item icon="el-icon-edit" @click.native="dialogFormVisible = true">修改密码</el-dropdown-item>
            <router-link to="/">

              <el-dropdown-item icon="el-icon-right" @click.native="clearlogin()">退出登录</el-dropdown-item>
            </router-link>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="30%" center append-to-body>
          <el-form class="flexcontent">
            <el-input v-model="newpassword" placeholder="新密码" show-password></el-input>
            <el-input v-model="surepassword" placeholder="确认密码" show-password></el-input>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="changepassword">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div class="login login-menu-login" v-else>
        <ul>
          <li class="loginicon" v-for="(item, i) in loginItems" :key="i" @click="toLink(item.link, $event)" @change="change" :class="{ selected: item.isSelected }">
            <img :src="item.icon" alt="" /><span>{{ item.text }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>
</template>

<script>
const imgUrl = "https://ringstar.xhqj71.com/jeecg-boot/sys/common/static/"; //公共路径
const navItems = [{
    text: "首页",
    link: "/",
    isSelected: "",
    isred: true
  },
  {
    text: "圈子",
    link: "/about",
    isSelected: "",
    isred: true
  },
  {
    text: "圈友",
    link: "/friend",
    isSelected: "",
    isred: true
  },
  {
    text: "动态",
    link: "/moments",
    isSelected: "",
    isred: true
  },
  {
    text: "企业",
    link: "/job",
    isSelected: "",
    isred: true
  },
  {
    text: "询价",
    link: "/price",
    isSelected: "",
    isred: true
  }
];

const loginItems = [{
    value: "login",
    text: "登录",
    link: "/login",
    icon: require("../assets/images/login_3.png"),
    isSelected: "false"
  },
  {
    value: "register",
    text: "注册",
    link: "/reg",
    icon: require("../assets/images/reg_2.png"),
    isSelected: "false"
  }
];
const changeItems = [{
    value: "login",
    text: "登录蓝",
    link: "/login",
    icon: require("../assets/images/login_2.png"),
    isSelected: "true"
  },
  {
    value: "register",
    text: "注册灰",
    link: "/reg",
    icon: require("../assets/images/reg_2.png"),
    isSelected: "false"
  },
  {
    value: "login",
    text: "登录灰",
    link: "/login",
    icon: require("../assets/images/login_3.png"),
    isSelected: "true"
  },
  {
    value: "register",
    text: "注册蓝",
    link: "/reg",
    icon: require("../assets/images/reg_3.png"),
    isSelected: "false"
  }
];
import router from "../router";
import {
  Changepassword
} from "../api/api"
import {
  queryById
} from "../api/api"
export default {
  name: "transparentheaders",
  data() {
    return {
      topBannerNavBg: {
        backgroundColor: ""
      },
      navItems: navItems,
      loginItems: loginItems,
      changeItems: changeItems,
      hasToken: false,
      username: "",
      headicon: "",
      imgUrl,
      userid: "",
      dialogFormVisible: false,
      newpassword: "",
      surepassword: "",
      msg: "",
      novisible: false,
    };
  },

  mounted() {
    const value = this.$store.state.globalVariable;
    if (value == 0) {
      this.navItems[2].isred = true;
    }
    // var websocket = null;
    // const self = this;
    // //定时器 只执行一次的那种 只是为了限制重连频率 = =
    // var heartCheck = {
    //   timeout: 200, //重连时间
    //   timeoutObj: null,
    //   start: function () {
    //     this.timeoutObj = setTimeout(function () {
    //       //连接成功建立的回调方法
    //       var websocket = null;

    //       var userId = JSON.parse(
    //         sessionStorage.getItem("userinfo_Data")
    //       ).id

    //       if ('WebSocket' in window && !websocket) {
    //         // websocket = new WebSocket("wss://www.xhqj71.com/jeecg-boot/websocketRingStar/" + userId);
    //         websocket = new WebSocket("ws://q66uqq.natappfree.cc/jeecg-boot/websocketSingle/" + userId);
    //       } else {
    //         alert('当前浏览器 Not support websocket')
    //       }
    //       let isConnected = false;
    //       //连接发生错误的回调方法
    //       websocket.onerror = function () {
    //         console.log("WebSocket连接发生错误");
    //       };

    //       //连接成功建立的回调方法
    //       if (!isConnected) {
    //         websocket.onopen = function connectWebSocket() {
    //           console.log("WebSocket连接成功");
    //           isConnected = true;
    //         }

    //       }
    //       websocket.onclose = function (e) {
    //         console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
    //         heartCheck.start();
    //       }
    //       //接收到消息的回调方法

    //       websocket.onmessage = (event) => {
    //         console.log(event.data);
    //         console.log(self.navItems[2])
    //         self.navItems[2].isred = false;
    //         self.$store.commit('updateGlobalVariable', 1);
    //         self.someValue = event.data
    //         //  this.playAudio()
    //         let buttonAudio = document.getElementById('my_audio');
    //         var audio = require('../assets/audios/y1479.mp3')
    //         buttonAudio.setAttribute('src', audio)
    //         buttonAudio.play()
    //       }
    //       window.onbeforeunload = function () {
    //         websocket.close();
    //       } //这里重新创建 websocket 对象并赋值
    //     }, this.timeout)
    //   }
    // }
    // var userId = JSON.parse(
    //   sessionStorage.getItem("userinfo_Data")
    // ).id
    // if ('WebSocket' in window) {
    //   // websocket = new WebSocket("wss://www.xhqj71.com/jeecg-boot/websocketRingStar/" + userId);
    //   websocket = new WebSocket("ws://q66uqq.natappfree.cc/jeecg-boot/websocketSingle/" + userId);
    // } else {
    //   alert('当前浏览器 Not support websocket')
    // }

    // //连接发生错误的回调方法
    // websocket.onerror = function () {
    //   console.log("WebSocket连接发生错误");
    // };
    // let isConnected = false;
    // //连接发生错误的回调方法

    // //连接成功建立的回调方法
    // if (!isConnected) {
    //   websocket.onopen = function connectWebSocket() {
    //     console.log("WebSocket连接成功");
    //     isConnected = true;
    //   }
    //   websocket.onclose = function (e) {
    //     console.log('websocket 断开: ' + e.code + ' ' + e.reason + ' ' + e.wasClean)
    //     heartCheck.start();
    //   }
    // }
    // //接收到消息的回调方法
    // websocket.onmessage = (event) => {
    //   console.log(event.data);
    //   this.navItems[2].isred = false;
    //   this.$store.commit('updateGlobalVariable', 1);
    //   this.someValue = event.data
    //   //  this.playAudio()
    //   let buttonAudio = document.getElementById('my_audio');
    //   var audio = require('../assets/audios/y1479.mp3')
    //   buttonAudio.setAttribute('src', audio)
    //   buttonAudio.play()
    // }
    // window.onbeforeunload = function () {
    //   websocket.close();
    // }
    if (this.hasToken) {
      this.roleId = this.$route.query.roleId
      this.userid = JSON.parse(
        sessionStorage.getItem("userinfo_Data")
      ).id
    }
    queryById({
      id: this.userid,
    }).then(res => {
      if (res.data.code == 200) {
        if (res.data.result.loginState) {
          this.msg = res.data.result.stop1Txt;
          this.open();
          sessionStorage.clear();
          this.$router.push({
            path: "/"
          });
        }
      }
    });
  },
  created() {

    this.change();
    this.islogin();
  },
  methods: {
    toLink(link, $event) {
      router.push(link || "/");
    },

    change() {
      //改变顶部栏样式
      var url = window.location.href;
      if (url.indexOf("login") > 0) {
        this.loginItems[0].isSelected = true;
        this.loginItems[1].isSelected = false;
        this.loginItems[0].icon = this.changeItems[0].icon;
        this.loginItems[1].icon = this.changeItems[1].icon;
        for (var i = 0; i < 6; i++) {
          this.navItems[i].isSelected = false;
        }
      }
      if (url.indexOf("reg") > 0) {
        this.loginItems[0].isSelected = false;
        this.loginItems[1].isSelected = true;
        this.loginItems[0].icon = this.changeItems[2].icon;
        this.loginItems[1].icon = this.changeItems[3].icon;
        for (var i = 0; i < 6; i++) {
          this.navItems[i].isSelected = false;
        }
      }
      if (url.indexOf("job") > 0) {
        this.navItems[0].isSelected = false;
        this.navItems[1].isSelected = false;
        this.navItems[2].isSelected = false;
        this.navItems[3].isSelected = false;
        this.navItems[5].isSelected = false;
        this.navItems[4].isSelected = true;
        for (var i = 0; i < 2; i++) {
          this.loginItems[i].isSelected = false;
        }
        this.loginItems[0].icon = this.changeItems[2].icon;
        this.loginItems[1].icon = this.changeItems[1].icon;
      }
      if (url.indexOf("about") > 0) {
        this.navItems[0].isSelected = false;
        this.navItems[4].isSelected = false;
        this.navItems[2].isSelected = false;
        this.navItems[3].isSelected = false;
        this.navItems[5].isSelected = false;
        this.navItems[1].isSelected = true;
        for (var i = 0; i < 2; i++) {
          this.loginItems[i].isSelected = false;
        }
        this.loginItems[0].icon = this.changeItems[2].icon;
        this.loginItems[1].icon = this.changeItems[1].icon;
      }
      if (url.indexOf("friend") > 0) {
        this.navItems[0].isSelected = false;
        this.navItems[1].isSelected = false;
        this.navItems[4].isSelected = false;
        this.navItems[3].isSelected = false;
        this.navItems[5].isSelected = false;
        this.navItems[2].isSelected = true;
        for (var i = 0; i < 2; i++) {
          this.loginItems[i].isSelected = false;
        }
        this.loginItems[0].icon = this.changeItems[2].icon;
        this.loginItems[1].icon = this.changeItems[1].icon;
      }
      if (url.indexOf("moments") > 0) {
        this.navItems[0].isSelected = false;
        this.navItems[1].isSelected = false;
        this.navItems[2].isSelected = false;
        this.navItems[4].isSelected = false;
        this.navItems[5].isSelected = false;
        this.navItems[3].isSelected = true;
        for (var i = 0; i < 2; i++) {
          this.loginItems[i].isSelected = false;
        }
        this.loginItems[0].icon = this.changeItems[2].icon;
        this.loginItems[1].icon = this.changeItems[1].icon;
      }
      if (url.indexOf("price") > 0) {
        this.navItems[0].isSelected = false;
        this.navItems[1].isSelected = false;
        this.navItems[2].isSelected = false;
        this.navItems[3].isSelected = false;
        this.navItems[4].isSelected = false;
        this.navItems[5].isSelected = true;
        for (var i = 0; i < 2; i++) {
          this.loginItems[i].isSelected = false;
        }
        this.loginItems[0].icon = this.changeItems[2].icon;
        this.loginItems[1].icon = this.changeItems[1].icon;
      }
      if (url.indexOf("mycenter") > 0) {
        for (let i = 0; i < 6; i++)
          this.navItems[i].isSelected = false;

      }
      if (url.indexOf("notice") > 0) {
        for (let i = 0; i < 6; i++)
          this.navItems[i].isSelected = false;
      }
      if (url.indexOf("history") > 0) {
        for (let i = 0; i < 6; i++)
          this.navItems[i].isSelected = false;
      }
    },

    islogin() {

      if (sessionStorage.getItem("token")) {
        this.hasToken = true;
        this.username = JSON.parse(
          sessionStorage.getItem("userinfo_Data")
        ).mininame;
        this.headicon = JSON.parse(
          sessionStorage.getItem("userinfo_Data")
        ).personPic;

      } else {
        this.hasToken = false;
      }
    },
    clearlogin() {
      this.hasToken = false;
      sessionStorage.clear();
    },
    load() {

    },
    open() {
      this.$msgbox({
        title: "提示",
        message: `${this.msg}`,
        type: "warning",
        center: true,
        confirmButtonText: "确定"
      }).then(() => {});
    },
    changepassword() {

      var passwordreg = /^[a-zA-Z\d]{6,16}$/;

      if (!passwordreg.test(this.newpassword)) {
        this.msg = "密码应为6-16位字符";
        this.open();;
      }
      if (this.newpassword !== this.surepassword) {
        this.msg = "两次密码不一致";
        this.open();

      }

      if (!(!passwordreg.test(this.newpassword) || this.newpassword !== this.surepassword)) {
        let data = {
          id: this.userid,
          password: this.surepassword,
        };
        // console.log(data);
        Changepassword(data).then(res => {
          if (res.data.code == 200) {
            this.msg = res.data.message;
            this.open();
            this.dialogFormVisible = false;
            this.newpassword = ""
            this.surepassword = ""
          }
        });

      }

    }

  }
};
</script>

<style lang="scss" scoped>
.selected {
  border: solid 1px rgb(10, 108, 255);
  color: rgb(10, 108, 255);
}

.headpicture {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
}

.el-input {
  width: 300px;
  margin-bottom: 20px;
}

>>>.el-dialog--center .el-dialog__body {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/transparentheaders.vue